// @flow

/**
 * @module Constants/Settlements
 * @desc Settlement Constants
 */

import keyMirror from 'fbjs/lib/keyMirror';

/**
 * @constant {Object} ApplicationConstants
 * @memberof Application
 */
export const SettlementConstants = keyMirror({
  GET_SETTLEMENTS: undefined,
  CONFIRM_CDA: undefined,
  UPDATE_COUNTER_OFFER_STATUS: undefined,
  GET_BANK_DETAILS: undefined,
});



// WEBPACK FOOTER //
// ./src/constants/settlement.js